<template>
    <carousel 
        v-bind="$attrs"
        v-on="$listeners"
        ref="my_carousel"
    >
        <template
            v-for="(slot, name) in $slots"
            :slot="name"
        >
            <slot v-if="name === 'default'"></slot>
            <slot v-if="name !== 'default'" :name="name"></slot>
        </template>

        <template
            v-for="(slot, name) in $scopedSlots"
            :slot="name"
            slot-scope="props"
        >
            <slot :name="name" v-bind="props"></slot>
        </template>

        <template v-slot:pagination>
            <custom-pagination 
                @paginationclick="goToPage($event, 'pagination')" 
                :show-title="showTitle" 
            />
        </template>

    </carousel>
</template>

<script>
import CustomPagination from './CustomPagination'
import VueCarousel from 'vue-carousel'
import Vue from 'vue/dist/vue.js';
Vue.use(VueCarousel)

export default {
    inheritAttrs: false,

    components:{
        'custom-pagination': CustomPagination,
    },

    props:{
        showTitle: {
            type: Boolean,
            default: false,
        },
    },

    methods:{
        goToPage(page,type) {
            this.$refs.my_carousel.goToPage(page, type)
        },
    }
}
</script>